module.exports = __webpack_public_path__ + "static/media/notification.a96b27f0.wav";